import { SANDBOX_PRESET_TAG as T } from '../presetTags'
import { SANDBOX_PRESET_BODY_CSS, type SandboxComponentPreset } from '../../sandboxPresetTypes'

/**
 * Skeleton = gray blocks whose **background-position** animates (shimmer). Toggle `hidden` on `.sk` vs `#real`
 * to mimic “content arrived” — in real apps you’d swap React/Vue state or fetch HTML.
 */
const shell = SANDBOX_PRESET_BODY_CSS

const preset: SandboxComponentPreset = {
  id: 'skeleton-shimmer',
  category: 'loading',
  title: 'Skeleton shimmer',
  description: 'Shimmer placeholders; Simulate load swaps in real content.',
  tags: [T.loading, T.skeleton],
  html: `<h2>Card</h2>

<!-- Fake layout: varied .line widths suggest text blocks -->
<div class="sk"><div class="line w40"></div><div class="line w80"></div><div class="line w65"></div><div class="line w55"></div></div>

<!-- Shown after timeout; starts hidden -->
<div id="real" hidden class="real"><p><strong>Loaded.</strong> Fake fetch complete.</p><p>Use Reset to try again.</p></div>

<p><button type="button" id="load">Simulate load</button> <button type="button" id="reset">Reset</button></p>`,
  css: `${shell}

h2 {
  color: var(--nogrok-preview-primary);
  margin: 0 0 1rem;
}

.sk {
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-container);
  max-width: 22rem;
}

.line {
  height: 12px;
  border-radius: 4px;
  margin-bottom: 12px;
  /* Wide gradient + background-size lets position animation slide the highlight */
  background: linear-gradient(90deg, var(--nogrok-preview-shimmer-a) 0%, var(--nogrok-preview-shimmer-b) 45%, var(--nogrok-preview-shimmer-a) 90%);
  background-size: 200% 100%;
  animation: sh 1.2s ease-in-out infinite;
}

.line.w40 {
  width: 40%;
}
.line.w80 {
  width: 80%;
}
.line.w65 {
  width: 65%;
}
.line.w55 {
  width: 55%;
}

@keyframes sh {
  0% {
    background-position: 100% 0;
  }
  100% {
    background-position: -100% 0;
  }
}

.real {
  padding: 1rem;
  border-radius: 10px;
  border: 1px solid color-mix(in srgb, var(--nogrok-preview-primary) 25%, transparent);
  background: var(--nogrok-preview-shimmer-bg);
  max-width: 22rem;
}

button {
  font: inherit;
  padding: 0.45rem 0.85rem;
  border-radius: 6px;
  border: 1px solid var(--nogrok-preview-outline);
  background: var(--nogrok-preview-surface-rail);
  color: var(--nogrok-preview-on-surface);
  cursor: pointer;
  margin-right: 0.5rem;
}`,
  js: `const sk = document.querySelector('.sk')
const real = document.getElementById('real')

document.getElementById('load')?.addEventListener('click', () => {
  window.setTimeout(() => {
    sk?.setAttribute('hidden', '')
    real?.removeAttribute('hidden')
  }, 600)
})

document.getElementById('reset')?.addEventListener('click', () => {
  real?.setAttribute('hidden', '')
  sk?.removeAttribute('hidden')
})`,
}

export default preset
